export enum BTControl{
    hide = 1,
    show = 2,
    showAgain = 3,
    notDisplay = 4,
    borderOnly = 5

}



// WEBPACK FOOTER //
// ./src/app/stocks/models/b-t-control.ts